import { CssBaseline } from "@mui/material";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/animations.css';
import './styles/index.css';
import './styles/truck.css';
// import './styles/sh_daterangepicker.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// import { AxiosBackendWrapper, AxiosWrapper } from './api/Wrappers';
import './i18n';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './newapi/store';
import ThemeManager from './ThemeManager';
import { suppressConsoleWarnings } from './warningsuppresor';
import { installFeedbackContext } from './utils/feedbackContext';

installFeedbackContext();

const hardTest = false;
const executeServiceWorker= true;
// process.env.NODE_ENV === "production" ? true : hardTest;

// const swUrl = process.env.NODE_ENV === 'production'
//   ? `${process.env.PUBLIC_URL}/service-worker.js`
//   : '/service-worker.js';
  
suppressConsoleWarnings();

// Registering service worker
if ('serviceWorker' in navigator) {
  // console.log("serviceworker")
  if(executeServiceWorker){
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL}/service-worker.js`)
        .then((registration) => {

          // Check for updates on page load
          registration.update();

          // Listen for waiting service worker
          if (registration.waiting) {
            showUpdateAvailable(registration);
          }

          // Listen for new service worker installing
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                showUpdateAvailable(registration);
              }
            });
          });

          // Listen for messages from the service worker
          navigator.serviceWorker.addEventListener('message', event => {

            if (event.data && event.data.type === 'RELOAD') {
              // window.location.reload();
            }

            if (event.data && event.data.type === 'DOWNLOAD_EXPORT') {
              // Trigger download when notification action is clicked
              const { blobUrl, exportId } = event.data;
              if (blobUrl) {
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = `export_${exportId}_${new Date().toISOString().split('T')[0]}.xlsx`;
                a.target = '_blank';
                document.body.appendChild(a);
                a.click();
                a.remove();
              }
            }
          });

          // Store registration globally for manual update checks
          window.swRegistration = registration;

        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });

    // Function to show update notification
    function showUpdateAvailable(registration) {
     
      // Dispatch custom event for UpdateNotification component
      const updateEvent = new CustomEvent('updateAvailable', {
        detail: { type: 'UPDATE_AVAILABLE', registration }
      });
      window.dispatchEvent(updateEvent);
    }

    // Enhanced function to check for updates that can be called externally
    window.checkForSWUpdates = () => {
      if (navigator.serviceWorker.ready) {
        navigator.serviceWorker.ready.then((registration) => {

          registration.update().then(() => {

          }).catch((error) => {

          });
        });
      }
    };

    // Force update PWA - immediately activates waiting service worker and reloads
    window.forceUpdatePWA = () => {
      if (window.swRegistration && window.swRegistration.waiting) {
        // Tell the waiting SW to skip waiting and activate immediately
        window.swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
        // Reload the page after activation
        window.location.reload();
      } else {
        // Check for updates first
        window.checkForSWUpdates();
      }
    };

    // Check for updates periodically (every 60 seconds)
    setInterval(() => {

      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'CHECK_FOR_UPDATE' });
      }
    }, 60000);

  } else {
    window.addEventListener("load", () => {
      navigator.serviceWorker.ready.then(registration => {
        registration.unregister().then(() => {

          if (caches) {
            caches.keys().then(async (names) => {
              await Promise.all(names.map(name => caches.delete(name)));
            });
          }
        });
      });
    });
  }
}

// import { refresh } from './api/global/user';
const Root = () => {
  // const dispatch = useDispatch();
  // const themeMode = useSelector(selectThemeMode);
  // const theme = getTheme(themeMode);
  // const [theme, colorMode, setColorMode] = useMode();
  // const colors = tokens(theme);


  // const [authTokens, auth] = useAuth();
  // console.log(auth);

  // const listenForThemeChange = (e) => {
  //   const colorScheme = e.matches ? "dark" : "light";
  //   // setColorMode.setColorMode(colorScheme);
    
  //   dispatch(setThemeMode(colorScheme));
  //   if(collapsed && window.innerWidth <=1366){
  //       document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#181820": "#ecf0f5"}`);
  //       document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#181820": "#ecf0f5"}`);
  //   } else {
  //       document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? colors.bg["secondary"]: colors.bg["primary"]}`);
  //       document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? colors.bg["secondary"]: colors.bg["primary"]}`);
  //   }
  // }
  
  // useEffect(() => {
  //   let query = window.matchMedia("(prefers-color-scheme: dark)");
  //   if (query.addEventListener) {
  //     query.addEventListener('change', listenForThemeChange);
  //   } else {
  //     query.addListener(listenForThemeChange);
  //   }

  //   return () => {
  //     if (query.removeEventListener) {
  //       query.removeEventListener('change', listenForThemeChange);
  //     } else {
  //       query.removeListener(listenForThemeChange);
  //     }
  //   }
  // }, []);


  return (
    // <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
              <ThemeManager>
                <CssBaseline />
                <App/>
              </ThemeManager>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    // </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
